import {tagManagement} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";
import {isExpired} from "../../basic/response";

export default {
	queryTagLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: tagManagement.queryTagLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    updTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: tagManagement.updTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    batchUpdTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: tagManagement.batchUpdTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getFavorTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: tagManagement.getFavorTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    updFavorTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: tagManagement.updFavorTag,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    // getTagTreeMenu(vue, query) {
    //     return new Promise((resolve, reject) => {
    //         let requestModel = new RequestModel({
    //                 method: 'get',
    //                 url: tagManagement.getTagTreeMenu,
    //                 data: query.data ? query.data : {},
    //                 params: query.params ? query.params : {}
    //             }),
    //             request = requestModel.tokenConfig();
    //         vue.axios(request).then(function (result) {
    //             resolve(result);
    //         })
    //     });
    // },
    getFitlerMyTagTree(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: tagManagement.getFitlerMyTagTree,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getChartByDim(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: tagManagement.getChartByDim,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getTagsByLevel(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: tagManagement.getTagsByLevel,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    queryRoleTags(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: tagManagement.queryRoleTags,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    searchTagVal(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: tagManagement.searchTagVal,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getTagsByName(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: tagManagement.getTagsByName,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}
